module.exports = __webpack_public_path__ + "/img/Oscillator-LBend-Labeled-U2ogJM.svg";